export default "__VITE_ASSET__CqVX9DCz__"